import Collapse from 'bootstrap.collapse';
import { fetch } from 'utils';

let timer;

document.addEventListener('input', e => {
    const search = e.target.closest('.shop-search-widget');

    if (!search)
        return;

    const dropdown = Collapse.getOrCreateInstance(search.querySelector('.dropdown'), { toggle: false });
    const input = e.target;
    const query = input.value.trim();

    if (query.length < 3 && (query.length !== 0 || window.innerWidth >= 992)) {
        dropdown.hide();
        return;
    }

    if (timer)
        clearTimeout(timer);

    timer = setTimeout(async () => {
        // Use 'carp' if the input is blank on mobile
        const searchTerm = query.length >= 3 ? query : 'carp';

        const response = await fetch(`/api/shop-search?search=${searchTerm}&maxProductListings=${search.$data.parameters?.maxProductListings ?? ''}&maxCategories=${search.$data.parameters?.maxCategories ?? ''}&maxBrands=${search.$data.parameters?.maxBrands ?? ''}`, {
            method: 'GET'
        });
        const data = await response.json();

        search.$data.productListings = data.productListings;
        search.$data.categories = data.categories;
        search.$data.brands = data.brands;
 
        // Make sure the data has been set before toggling the dropdown
        search.$data.$nextTick(() => {
            if (search.$data.productListings.length || search.$data.categories.length || search.$data.brands.length)
                dropdown.show();
            else
                dropdown.hide();
        });
    }, 500); 
});

// Observe when the search dropdown opens/closes
const darkness = document.querySelector('#darkness');
const searchDropdown = document.querySelector('#search-dropdown');

if (window.innerWidth >= 992 && searchDropdown) {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'class') {
                if (searchDropdown.classList.contains('show')) {
                    darkness.style.opacity = 0;
                    darkness.style.display = 'block';
                    setTimeout(() => {
                        darkness.style.opacity = 1;
                    });
                } else {
                    darkness.style.display = 'none';
                }
            }
        });
    });

    observer.observe(searchDropdown, { attributes: true });
}

// DESKTOP: Close search when clicking outside
document.addEventListener('click', (event) => {
    if (window.innerWidth >= 992) {
        if (!searchDropdown.contains(event.target)) {
            searchDropdown.classList.remove('show');
        }
    }
});

// MOBILE: Handle Mobile Search Toggle
const placeholderSearch = document.getElementById('placeholder-search');
const shopSearchWidget = document.querySelector('.shop-search-widget');

// The actual input inside the overlay
const mobileSearchInput = shopSearchWidget.querySelector('input');

if (placeholderSearch && shopSearchWidget && mobileSearchInput) {
    placeholderSearch.addEventListener('touchstart', async (event) => {
        event.preventDefault();
        shopSearchWidget.classList.add('show');

        // Focus the input
        mobileSearchInput.focus({ preventScroll: true });

        // Trigger default search for "carp" if input is blank
        if (!mobileSearchInput.value) {
            const dropdown = new Collapse(shopSearchWidget.querySelector('.dropdown'), { toggle: false });

            const response = await fetch(`/api/shop-search?search=carp&maxProductListings=${shopSearchWidget.$data.parameters?.maxProductListings ?? ''}&maxCategories=${shopSearchWidget.$data.parameters?.maxCategories ?? ''}&maxBrands=${shopSearchWidget.$data.parameters?.maxBrands ?? ''}`, {
                method: 'GET'
            });
            const data = await response.json();

            shopSearchWidget.$data.productListings = data.productListings;
            shopSearchWidget.$data.categories = data.categories;
            shopSearchWidget.$data.brands = data.brands;

            shopSearchWidget.$data.$nextTick(() => {
                if (shopSearchWidget.$data.productListings.length || shopSearchWidget.$data.categories.length || shopSearchWidget.$data.brands.length)
                    dropdown.show();
                else
                    dropdown.hide();
            });
        }
    });
}

//Hide keyboard when dropdown is touched/swiped
if (shopSearchWidget && searchDropdown && mobileSearchInput) {
    // On mobile, detect touchstart inside the dropdown
    searchDropdown.addEventListener('touchstart', () => {
        // Blur the input to hide the keyboard
        mobileSearchInput.blur();
    });
}

// MOBILE: Close search when clicking close button
const searchCloseBtn = shopSearchWidget.querySelector('.search-close');

if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', () => {
        shopSearchWidget.classList.remove('show');

        // Hide the darkness overlay
        darkness.style.opacity = 0;
        darkness.style.display = 'none';
    });
}

// Typewriting Search Text
const phrases = ["Barbless hooks", "Korda", "Float rods", "Boilies", "Preston Innovations", "Frozen bait", "Monofilament", "T-shirts", "Chair", "Nash", "Carp Rods", "Feeder tips", "Top kits", "Leads", "Vouchers", "Floats", "Matrix", "Swivels", "MAP", "Delkim"
];

const desktopInput = document.getElementById("Search");
const mobileInput = document.getElementById("placeholder-search");

const desktopOriginalPlaceholder = desktopInput ? desktopInput.placeholder : "";
const mobileOriginalPlaceholder = mobileInput ? mobileInput.placeholder : "";

let currentPhrase = 0;
let currentChar = 0;
let isDeleting = false;

function typeEffect() {
    // Desktop typewriter (only if >=992px)
    if (desktopInput) {
        if (window.innerWidth >= 992) {
            const fullText = phrases[currentPhrase];
            const displayedText = fullText.substring(0, currentChar);
            desktopInput.placeholder = displayedText;

            if (!isDeleting) {
                if (currentChar < fullText.length) {
                    currentChar++;
                } else {
                    isDeleting = true;
                    setTimeout(typeEffect, 1000);
                    return;
                }
            } else {
                if (currentChar > 0) {
                    currentChar--;
                } else {
                    isDeleting = false;
                    currentPhrase = (currentPhrase + 1) % phrases.length;
                }
            }
        } else {
            // Restore original placeholder on mobile
            desktopInput.placeholder = desktopOriginalPlaceholder;
        }
    }

    // Mobile input typewriter (always)
    if (mobileInput) {
        const fullText = phrases[currentPhrase];
        const displayedText = fullText.substring(0, currentChar);
        mobileInput.placeholder = displayedText;

        if (!isDeleting) {
            if (currentChar < fullText.length) {
                currentChar++;
            } else {
                isDeleting = true;
                setTimeout(typeEffect, 1000);
                return;
            }
        } else {
            if (currentChar > 0) {
                currentChar--;
            } else {
                isDeleting = false;
                currentPhrase = (currentPhrase + 1) % phrases.length;
            }
        }
    }

    setTimeout(typeEffect, isDeleting ? 50 : 100);
}

// Initialize placeholders
if (desktopInput) desktopInput.placeholder = desktopOriginalPlaceholder;
if (mobileInput) mobileInput.placeholder = mobileOriginalPlaceholder;

typeEffect();